import { SUPPORTED_THEMES } from '../shared/supportedThemes';

export const CURRENT_CONFIGURED_THEME = SUPPORTED_THEMES.DEFAULT;
